import { http } from '@martech-solution/utils/utils';
import { PermissionEn } from 'src/constants/permission.enum';
import { FlatItem } from 'src/types/elements.type';
import { IEmployeeWithDepartment } from 'src/types/master_data/employee.type';
import { IRole, RoleAdd } from 'src/types/master_data/role.type';
import { PagedList } from 'src/types/pagedList.type';

const controller = 'master-data/roles';

export const getRoles = async (
  searchCondition: string | undefined,
  sequenceStatus: string,
  page: number,
  pageSize: number,
  orderBy?: string,
  appInfoId?: number
) => {
  return await http.get<PagedList<IRole>>(`${controller}`, {
    params: {
      name: searchCondition,
      sequenceStatus,
      page,
      pageSize,
      orderBy,
      appInfoId
    }
  });
};

export const getRole = async (id: number) => {
  return http.get<IRole>(`${controller}/${id}`);
};

export const getRoleByPermission = async (permissionCode: PermissionEn) => {
  return http.get<IRole[]>(`${controller}/get-by-permission`, {
    params: {
      permissionCode
    }
  });
};

export const addRole = async (role: RoleAdd) => {
  return http.post<RoleAdd>(controller, role);
};

export const updateRole = async (id: number, role: IRole) => {
  return await http.put(`${controller}/${id}`, role);
};

export const deleteRole = async (id: number) => {
  await http.delete(`${controller}/${id}`);
};

export const getRolesDropdown = async () => {
  return http.get<FlatItem[]>(`${controller}/dropdown`);
};

export const getEmployeesByRoleCode = async (code = 'proposal') => {
  return await http.get<IEmployeeWithDepartment[]>(`${controller}/employees-by-role-code/${code}`);
};
